/** All timestamps are stored in UTC; this is only the default display timezone. */
export const DEFAULT_TIMEZONE = "Europe/Vienna";
